export default "__VITE_ASSET__xk3_6X23tKf_Scjj9W5unA__"